var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{class:{ overlay: _vm.isTutorialActive }},[_c('div',{staticClass:"top-overlay"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }